import React from 'react';
import Helmet from 'react-helmet';
import config from "./../../data/SiteConfig";

const HelmetHeader = ({ data }) => {
  const { title, meta } = data;
  const blogURL = config.siteUrl + config.pathPrefix;
  // const description = config.siteDescription;
  const schemaOrgJSONLD = [
    {
      "@context": "http://schema.org",
      "@type": "WebSite",
      url: blogURL,
      name: title,
      alternateName: config.siteTitleAlt ? config.siteTitleAlt : ""
    }
  ];
  return (
    <Helmet
      defaultTitle="Berlin Robotics" titleTemplate={`%s | Berlin Robotics`}
      title={title}
    >
      {/* <meta name="description" content={description} /> */}
      <html lang="en" />
      {/* Schema.org tags */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgJSONLD)}
      </script>

      {meta && meta.map((meta, index) => <meta key={index} name={meta.name} content={meta.content} />)}

      <meta name="twitter:site" content="@BerlinRobotics" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Berlin Robotics" />
      {/* <meta name="docsearch:version" content="2.0" /> */}
      <link
        rel="canonical"
        href="https://berlin-robotics.github.io/"
      />

    </Helmet>
  );
}

export default HelmetHeader;